import { createSelector } from 'reselect';
import { selectAllCategories } from './selectAllCategories';

const filtration = (categories) => categories.filter((category) => category.block === 'Каталог');

export const selectCatalogCategories = createSelector(selectAllCategories, filtration);
